import React, { useMemo } from 'react';

import SubmissionLoader from '../Loader/SubmissionLoader';
import RenderIfAvailable from '../RenderIfAvailable';
import useEventListener from '../../hooks/useEventListener';
import { ENTER_KEY, KEY_DOWN_TEXT, SUMBIT_TEXT } from '../../GlobalConstant';

import styles from './Button.module.scss';

// loaderColor: colour of the submitting dots (white by default), for light buttons
const Button = ({ id, text, btnType = "primary", callBack, icnUrl, style, disabled = false, imgStyle = "", isSubmitting, type, loaderColor }) => {

  const handleClick = () => {
    callBack?.(id)
  }
  const handleSubmitForm = (event) => {
    if (event.key === ENTER_KEY) {
      event.preventDefault();
      handleClick();
    }
  }
  useEventListener(KEY_DOWN_TEXT, handleSubmitForm, type === SUMBIT_TEXT)

  return <>
    {isSubmitting ? <div className={styles.screenOverlay}></div> : null}
    <button
      id={id}
      className={`${styles.btn} ${styles[`btn--${btnType}`]} ${style} ${isSubmitting ? styles.hiddenText : ''}`}
      onClick={handleClick}
      disabled={disabled}
    >
      <RenderIfAvailable value={isSubmitting}>
        <div className={styles.submissionLoader}>
          <SubmissionLoader color={loaderColor} />
        </div>
      </RenderIfAvailable>
      <>
        <span>{text}</span>
        <RenderIfAvailable value={icnUrl}>
          <span className={`${styles['btn-icn']} ${imgStyle}`}>
            <img src={icnUrl} alt='' />
          </span>
        </RenderIfAvailable>
      </>
    </button>
  </>
}

export default React.memo(Button) 